import { useLazyQuery, useQuery } from "@apollo/client";
import { ORDER_LINES } from "../order-line.queries";
import { OrderLinesQuery, OrderLinesQueryVariables } from "../../../__generated__/OrderLinesQuery";

export const useOrderLines = (variables: OrderLinesQueryVariables) => {
  return useQuery<OrderLinesQuery, OrderLinesQueryVariables>(ORDER_LINES, { variables });
};

export const useLazyOrderLines = () => {
  return useLazyQuery<OrderLinesQuery, OrderLinesQueryVariables>(ORDER_LINES);
};
